<template>
	<div @click="node.onClick" class="display-flex flex-row width-100 flex-align-center flex-justify-space-between menu-item-container py-1">
		<div class="menu-item-title">{{ menuItemTitleText }}</div>
		<div class="test-result display-flex flex-row flex-align-center flex-justify-space-between">
			<component v-bind:is="getErrorIcon" />
			<div class="ml-1 test-result-text">
				{{ nodeTestStatus }}
				<AnemicButton class="ml-1 go-to-step-button">Go to step</AnemicButton>
			</div>
		</div>
	</div>
</template>

<script>
import { getAction } from '@/store/modules/actions/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import { getService } from '@/store/modules/apps/getters';
export default {
	name: 'PublishErrorsDropdownMenuItem',
	props: { node: { type: Object } },
	computed: {
		...mapGettersShorthand({ getAction, getService }),
		actionId() {
			return this.node.action;
		},
		serviceId() {
			return this.node.service;
		},
		serviceData() {
			return this.getService(this.serviceId) || {};
		},
		actionData() {
			return this.getAction(this.actionId) || {};
		},
		actionName() {
			return this.actionData.title;
		},
		getStepName() {
			return this.node.node_title || this.actionName || this.serviceData.service_name;
		},
		menuItemTitleText() {
			return `${this.getStepName}`;
		},
		nodeTestStatus() {
			if (this.isTestedError) {
				return 'Test failed';
			} else {
				return 'Not tested';
			}
		},
		isTestedError() {
			return WorkflowNodeService.isTestedError(this.node);
		},
		getErrorIcon() {
			return WorkflowNodeService.getTestIcon(this.node);
		},
	},
};
</script>
<style scoped lang="scss">
.menu-item-container {
	cursor: pointer;
	border-radius: 4px;
	transition: var(--transition-time);
	&:hover {
		background: #eeeffa;
		transition: var(--transition-time);
		.test-result,
		.go-to-step-button {
			display: inline-flex;
		}
	}
	&:active {
		filter: brightness(0.9);
		transition: var(--transition-time);
	}
}
.menu-item-title {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.test-result {
	min-width: 74px;
}
.test-result-text {
	font-size: 12px;
	line-height: 12px;
	color: var(--publish-button-test-result);
}
.go-to-step-button {
	width: 70px !important;
	height: 20px !important;
	font-size: 12px !important;
	border-radius: 8px !important;
	border: 1px solid var(--primary-color);
	background: var(--bg-color) !important;
	color: var(--primary-color) !important;
	display: none;
}
</style>
